import { useAuth } from '../lib/auth'
import { roleLabel } from '../lib/roles'
import { Alert, Button, Card, CardBody } from '../components/ui'
import { Logo } from '../components/Logo'

/* Government and platform roles have not been rebuilt in React yet. Showing
 * them the miner portal would quietly hide most of their tools, so send them
 * to the existing app instead and say plainly why. */
export default function Unsupported() {
  const { user, signOut } = useAuth()
  // Not the bare domain root - Firebase Hosting resolves "/" to this SPA's
  // own index.html before any rewrite rule runs (a platform quirk, not
  // something a rewrite can override), so a signed-in super_admin/gov
  // clicking through from "/" would just loop back to this same page.
  // /home is the Jinja app's own role-agnostic capability-driven landing
  // page (home_bp), genuinely reachable via the /home/** rewrite carve-out.
  const classic = '/home'

  return (
    <div style={{
      minHeight: '100dvh', display: 'grid', placeItems: 'center',
      padding: 'var(--sp-6)', background: 'var(--bg)',
    }}>
      <div style={{ width: '100%', maxWidth: 460 }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 'var(--sp-8)' }}>
          <Logo />
        </div>

        <Card pad>
          <h1 style={{ fontSize: 'var(--text-xl)', marginBottom: 'var(--sp-3)' }}>
            Your portal lives on the main site
          </h1>
          <p style={{ color: 'var(--text-muted)', marginBottom: 'var(--sp-5)' }}>
            You&rsquo;re signed in as <strong>{roleLabel(user)}</strong>. The new
            interface currently covers the miner and cooperative portals only —
            everything for your role is still on the main site.
          </p>

          <Alert tone="info">
            Your account, data and permissions are identical in both places.
            Nothing needs migrating.
          </Alert>

          <div style={{ display: 'flex', gap: 'var(--sp-3)', marginTop: 'var(--sp-6)' }}>
            <Button onClick={() => { window.location.href = classic }}>
              Go to the main site
            </Button>
            <Button variant="ghost" onClick={() => void signOut()}>Sign out</Button>
          </div>
        </Card>
      </div>
    </div>
  )
}

/* Shown inside the shell when a signed-in user hits a route that belongs to a
 * different portal than their role. */
export function WrongPortal() {
  return (
    <>
      <div className="page-head">
        <div>
          <h1>Not available for your role</h1>
          <p className="page-head__sub">
            This page belongs to a different portal.
          </p>
        </div>
      </div>
      <Card>
        <CardBody>
          <Alert tone="warning">
            Your account doesn&rsquo;t have access to this section. If you think
            that&rsquo;s wrong, ask your cooperative administrator to check your role.
          </Alert>
        </CardBody>
      </Card>
    </>
  )
}
